import { useEffect } from 'react'
import {
  logout,
  setLoggingOut,
  silentRefreshAction,
  subscribeToAuthBroadcast,
  syncAccessToken,
} from '../modules/authentication'
import { useAppDispatch } from '../modules/core'

export const useInit = () => {
  const dispatch = useAppDispatch()

  // Boot: silent refresh against the HttpOnly cookie.
  useEffect(() => {
    dispatch(silentRefreshAction()).catch(() => undefined)
  }, [dispatch])

  // Cross-tab auth sync.
  useEffect(() => {
    const unsubscribe = subscribeToAuthBroadcast(message => {
      if (message.type === 'logout') {
        // Suppress local refreshes during the originator's logout window so a
        // 401-driven refresh in this tab can't resurrect the cookie/session.
        setLoggingOut(true)
        dispatch(logout())
        setTimeout(() => setLoggingOut(false), 1000)
      } else if (message.type === 'token-refreshed') {
        dispatch(syncAccessToken(message.accessToken))
      }
    })
    return unsubscribe
  }, [dispatch])
}
